export const SIMPLE_CARD = {
  "Cardreport.Simplecard.Value.Color": {
    ref: "Color.Gray.900"
  },
  "Cardreport.Simplecard.Value.Font.Size": {
    ref: "Font.Size.24"
  },
  "Cardreport.Simplecard.Value.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Cardreport.Simplecard.Value.Font.Style": {
    defaultValue: "normal"
  },
  "Cardreport.Simplecard.Value.Text.Decoration": {
    defaultValue: "normal"
  },
  "Cardreport.Simplecard.Value.Padding.Top": {
    defaultValue: "0px"
  },
  "Cardreport.Simplecard.Value.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Cardreport.Simplecard.Value.Padding.Left": {
    defaultValue: "0px"
  },
  "Cardreport.Simplecard.Value.Padding.Right": {
    defaultValue: "0px"
  },
  "Cardreport.Simplecard.Label.Color": {
    ref: "Color.Gray.600"
  },
  "Cardreport.Simplecard.Label.Font.Size": {
    ref: "Font.Size.12"
  },
  "Cardreport.Simplecard.Label.Font.Style": {
    defaultValue: "normal"
  },
  "Cardreport.Simplecard.Label.Text.Decoration": {
    defaultValue: "normal"
  },
  "Cardreport.Simplecard.Label.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Cardreport.Simplecard.Label.Padding.Top": {
    defaultValue: "0px"
  },
  "Cardreport.Simplecard.Label.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Cardreport.Simplecard.Label.Padding.Left": {
    defaultValue: "0px"
  },
  "Cardreport.Simplecard.Label.Padding.Right": {
    defaultValue: "0px"
  },
  "Cardreport.Simplecard.Description.Color": {
    ref: "Color.Gray.600"
  },
  "Cardreport.Simplecard.Description.Font.Size": {
    ref: "Font.Size.11"
  },
  "Cardreport.Simplecard.Description.Font.Style": {
    defaultValue: "normal"
  },
  "Cardreport.Simplecard.Description.Text.Decoration": {
    defaultValue: "normal"
  },
  "Cardreport.Simplecard.Description.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Cardreport.Simplecard.Description.Padding.Top": {
    defaultValue: "0px"
  },
  "Cardreport.Simplecard.Description.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Cardreport.Simplecard.Description.Padding.Left": {
    defaultValue: "0px"
  },
  "Cardreport.Simplecard.Description.Padding.Right": {
    defaultValue: "0px"
  },
  "Cardreport.Simplecard.Content.Vertical.Gap": {
    defaultValue: "0px"
  }
};
